import React, { useState } from "react";
import styled, { css } from "styled-components";
import { isEmpty } from "../../util/util";

// Styled Components
const DetailsWrapper = styled.div`
	width: 100%;
	margin: 0 auto;
	overflow: hidden;
	border-radius: 0.5rem;
	background-color: ${(props) => (props.isExpanded ? "#FFF" : "")};
	max-height: ${(props) => (props.isExpanded ? "300rem" : "52px")};
	transition: max-height 0.5s cubic-bezier(0, 1, 0, 1), background-color 0.3s ease-in-out;
`;

const DetailsHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.75rem 1rem;
	transition: background-color 0.3s ease;

	&:hover {
		${(props) =>
			!props.disableCollapse &&
			css`
				cursor: pointer;
			`}
	}
`;

const DetailsTitle = styled.h2`
	font-size: 1rem;
	font-weight: 700;
	color: #000;
`;

const DetailsContent = styled.div`
	padding: 0.75rem;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	border-radius: 0.5rem;
`;

const ChildGrid = styled.div`
	display: grid;
	grid-template-columns: ${(props) => (props.isList ? "1fr" : "repeat(auto-fill, minmax(210px, 1fr))")};
	gap: ${(props) => (props.isList ? "0.75rem" : "0.5rem")};
	align-items: start;
`;

const ChildWrapper = styled.div`
	min-width: 0;
`;

const Chevron = ({ isExpanded }) => (
	<span
		className={isExpanded ? "material-symbols-outlined rotate-up" : "material-symbols-outlined"}
		style={{ cursor: "pointer" }}>
		keyboard_arrow_down
	</span>
);

const DetailsComponent = ({ title, children, initiallyExpanded = false, disableCollapse, isList }) => {
	if (isEmpty(children)) disableCollapse = true;

	const expanded = initiallyExpanded || disableCollapse;
	const [isExpanded, setIsExpanded] = useState(expanded);

	return (
		<DetailsWrapper isExpanded={isExpanded}>
			<DetailsHeader
				disableCollapse={disableCollapse}
				onClick={() => {
					if (disableCollapse) return;
					setIsExpanded(!isExpanded);
				}}>
				<DetailsTitle>{title}</DetailsTitle>
				{disableCollapse ? "" : <Chevron isExpanded={isExpanded} />}
			</DetailsHeader>

			<DetailsContent isList={isList}>
				<ChildGrid isList={isList}>
					{React.Children.map(children, (child, index) => (
						<ChildWrapper key={index}>{child}</ChildWrapper>
					))}
				</ChildGrid>
			</DetailsContent>
		</DetailsWrapper>
	);
};

export default DetailsComponent;
